import React from 'react'

import Visibility from '@material-ui/icons/Visibility'
import { ReactSVG } from 'react-svg'

import { DevicesFilterType, QcFilterType } from '~/gqlcodegen/fms/types'

import { idleIcon, offlineIcon, onlineIcon } from './iconMap'

import { DOMAINS, SUBDOMAINS } from '.'

export const AUTOHIDE_DURATION_SNACKBAR = 5000

export const UNAUTHORIZED = 'Unauthorized'

export const LOCAL_STORAGE_KEY_USER = 'USER_DATA'

export const PAGINATION_RESULT_DEFAULT = {
  current: 1,
  totalPage: 1,
}

export const FLEET_TYPE = {
  ALVA_ONE: 'ACC-BN',
  ALVA_CERVO: 'ADC-BP',
  ALVA_N3: 'AEB-BP',
  ALVA_N3_NEXT: 'AEB-BT',
}

// jenis kendaraan (fleetType dalam lowercase), dulu di Productivity/Chart/helper.ts
export const VEHICLE_TYPE = {
  BUS: 'bus',
  BIKE: 'bike',
  TRUCK: 'truck',
  CAR: 'car',
  BLIND_VAN: 'blindvan',
}

export const FLEET_COMMAND_MAP = {
  [FLEET_TYPE.ALVA_ONE]: {
    CAN_ON: 'setdigout 1?',
    CAN_OFF: 'setdigout 0?',
  },
  [FLEET_TYPE.ALVA_CERVO]: {
    SUPERSOCO_LOCK: 'SUPERSOCO_LOCK',
    SUPERSOCO_UNLOCK: 'SUPERSOCO_UNLOCK',
    SUPERSOCO_POWERON: 'SUPERSOCO_POWERON',
    SUPERSOCO_OPENSEAT: 'SUPERSOCO_OPENSEAT',
  },
  [FLEET_TYPE.ALVA_N3_NEXT]: {
    N3_NEXTGENT_UNLOCK_KNOB: 'setdigout 1? 10',
  },
}

export const MAPPING_COMMANDS_TYPE = {
  SUPERSOCO_LOCK: 'SUPERSOCO_LOCK',
  SUPERSOCO_UNLOCK: 'SUPERSOCO_UNLOCK',
  SUPERSOCO_POWERON: 'SUPERSOCO_POWERON',
  SUPERSOCO_OPENSEAT: 'SUPERSOCO_OPENSEAT',
  CAN_ON: 'setdigout 1?',
  CAN_OFF: 'setdigout 0?',
  N3_NEXTGENT_UNLOCK_KNOB: 'setdigout 1? 10',
}

export const SNACKBAR_OPTIONS = {
  DURATION: 10000,
  SIZE: 'md',
}

export const RESPONSE_MESSAGE = {
  CREATED_OK: 'Data Saved Successfully',
  UPDATED_OK: 'Data Updated Successfully',
  DELETED_OK: 'Data Deleted Successfully',
  ASSIGN_OK: 'Data Assigned Successfully',
  UNASSIGN_OK: 'Data Unassigned Successfully',
  DEFAULT: 'Something went wrong',
}

export const PAGINATION_OPTIONS = [
  {
    value: 5,
    label: '5/page',
  },
  {
    value: 10,
    label: '10/page',
  },
  {
    value: 15,
    label: '15/page',
  },
]

export const VEHICLE_STATUS = {
  STOP: 'stop',
  MOVING: 'moving',
  IDLE: 'idling',
  NA: 'n/a',
}

export const VEHICLE_STATUS_LABEL_MAPPING = {
  [VEHICLE_STATUS.IDLE]: 'Idle',
  [VEHICLE_STATUS.MOVING]: 'Moving',
  [VEHICLE_STATUS.STOP]: 'Stop',
  [VEHICLE_STATUS.NA]: 'N/A',
}

export const DEVICES_FILTER_BY = {
  ALL: DevicesFilterType.None,
  ASSIGNED: DevicesFilterType.Assigned,
  UNASSIGNED: DevicesFilterType.Unassigned,
}

export const QC_FILTER = {
  ALL: QcFilterType.None,
  PASS: QcFilterType.Pass,
  FAIL: QcFilterType.Fail,
  NOT_TESTED: 'NOT_TESTED',
}

export const QC_STATUS_LABEL = {
  [QC_FILTER.NOT_TESTED]: 'Not Tested',
  [QC_FILTER.PASS]: 'QC Passed',
  [QC_FILTER.FAIL]: 'QC Failed',
}

export const QC_STATUS_COLOR = {
  [QC_STATUS_LABEL[QC_FILTER.FAIL]]: 'danger',
  [QC_STATUS_LABEL[QC_FILTER.PASS]]: 'success',
  [QC_STATUS_LABEL[QC_FILTER.NOT_TESTED]]: 'default',
}

export const ASSIGNED_STATUS_COLOR = {
  [DevicesFilterType.Assigned]: 'success',
  [DevicesFilterType.Unassigned]: 'danger',
}

export const QC_ICON = {
  [QC_STATUS_LABEL[QC_FILTER.FAIL]]: '',
  [QC_STATUS_LABEL[QC_FILTER.PASS]]: <Visibility className="responsive-icon" />,
  [QC_STATUS_LABEL[QC_FILTER.NOT_TESTED]]: '',
}

export const indonesiaPolygonCoordinate = [
  [
    [94.7717121989, -11.2085667762],
    [141.0200344026, -11.2085667762],
    [141.0200344026, 6.2744498481],
    [94.7717121989, 6.2744498481],
    [94.7717121989, -11.2085667762],
  ],
]

export const manufacturingArea = [
  [
    [107.163, -6.3405],
    [107.163, -6.3605],
    [107.183, -6.3605],
    [107.183, -6.3405],
    [107.163, -6.3405],
  ],
]

export const areaAEC = [
  [
    [106.799, -6.213],
    [106.799, -6.233],
    [106.819, -6.233],
    [106.819, -6.213],
    [106.799, -6.213],
  ],
]

export const ROW_SIZE = 70

export const PERMISSIONS_V2 = {
  // DASBOARD
  FMS_KALISTA_DASHBOARD_V2: 'FMS_KALISTA_DASHBOARD_V2',
  FMS_ALVA_DASHBOARD_V2: 'FMS_ALVA_DASHBOARD_V2',

  // ─── TRACKING ────────────────────────────────────────────────────────────────
  FMS_TRACKING_ALVA: 'FMS_TRACKING_ALVA_V2', // PAGE MAP (live tracking alva)
  FMS_TRACKING_KALISTA: 'FMS_TRACKING_KALISTA_V2', // PAGE TRACKING (kalista/bus)

  // ─── ASSET BIKE ──────────────────────────────────────────────────────────────
  FMS_ASSET: 'FMS_ASSET_V2', // PAGE ASSETS BIKE
  FMS_ASSET_LIST: 'FMS_ASSET_LIST_V2',
  FMS_ASSET_LIST_IMEI: 'FMS_ASSET_LIST_IMEI_V2', // column: show IMEI
  FMS_ASSET_LIST_SIMCARD: 'FMS_ASSET_LIST_SIMCARD_V2', // column: show SIM Card
  FMS_ASSET_LIST_ODOMETER: 'FMS_ASSET_LIST_ODOMETER_V2', // column: show Odometer
  FMS_ASSET_LIST_EDIT: 'FMS_ASSET_LIST_EDIT_V2', // action: edit asset from list
  FMS_ASSET_DETAIL: 'FMS_ASSET_DETAIL_V2', // PAGE ASSET DETAIL BIKE
  FMS_ASSET_DETAIL_INFO: 'FMS_ASSET_DETAIL_INFO_V2', // section: vehicle info
  FMS_ASSET_DETAIL_TECH: 'FMS_ASSET_DETAIL_TECH_V2', // tab: technical detail
  FMS_ASSET_DETAIL_EDIT: 'FMS_ASSET_DETAIL_EDIT_V2', // action: edit asset
  FMS_ASSET_DETAIL_ASSIGN_DRIVER: 'FMS_ASSET_DETAIL_ASSIGN_DRIVER_V2', // action: assign driver
  FMS_ASSET_DETAIL_SHARE_LOCATION: 'FMS_ASSET_DETAIL_SHARE_LOCATION_V2', // action: share location
  FMS_ASSET_DETAIL_EMERGENCY: 'FMS_ASSET_DETAIL_EMERGENCY_V2', // action: emergency
  FMS_ASSET_DETAIL_COMMAND: 'FMS_ASSET_DETAIL_COMMAND_V2', // action: send command
  FMS_ASSET_DETAIL_ON_OFF: 'FMS_ASSET_DETAIL_ON_OFF_V2', // action: on/off engine
  FMS_ASSET_DETAIL_MAP: 'FMS_ASSET_DETAIL_MAP_V2', // section: show map

  // ─── ASSET BUS / CAR ─────────────────────────────────────────────────────────
  FMS_ASSET_BUS: 'FMS_ASSET_BUS_V2', // PAGE ASSETS BUS
  FMS_ASSET_BUS_LIST: 'FMS_ASSET_BUS_LIST_V2',
  FMS_ASSET_BUS_LIST_EDIT: 'FMS_ASSET_BUS_LIST_EDIT_V2', // action: edit asset bus from list
  FMS_ASSET_BUS_DETAIL: 'FMS_ASSET_BUS_DETAIL_V2', // PAGE ASSET DETAIL BUS
  FMS_ASSET_BUS_DETAIL_INFO: 'FMS_ASSET_BUS_DETAIL_INFO_V2', // section: vehicle info
  FMS_ASSET_BUS_DETAIL_TECH: 'FMS_ASSET_BUS_DETAIL_TECH_V2', // tab: technical detail
  FMS_ASSET_BUS_DETAIL_EDIT: 'FMS_ASSET_BUS_DETAIL_EDIT_V2', // action: edit asset bus
  FMS_ASSET_BUS_DETAIL_ASSIGN_DRIVER: 'FMS_ASSET_BUS_DETAIL_ASGN_DRIVER_V2', // action: assign driver
  FMS_ASSET_BUS_DETAIL_COMMAND: 'FMS_ASSET_BUS_DETAIL_COMMAND_V2', // action: send command
  FMS_ASSET_BUS_DETAIL_ON_OFF: 'FMS_ASSET_BUS_DETAIL_ON_OFF_V2', // action: on/off engine
  FMS_ASSET_BUS_DETAIL_MAP: 'FMS_ASSET_BUS_DETAIL_MAP_V2', // section: show map

  // ─── DEVICES ─────────────────────────────────────────────────────────────────
  FMS_DEVICES: 'FMS_DEVICES_V2', // PAGE DEVICES
  FMS_DEVICES_LIST_EDIT: 'FMS_DEVICES_LIST_EDIT_V2', // action: edit device from list
  FMS_DEVICES_DETAIL: 'FMS_DEVICES_DETAIL_V2', // PAGE DEVICES DETAIL
  FMS_DEVICES_DETAIL_INFO: 'FMS_DEVICES_DETAIL_INFO_V2', // section: device info
  FMS_DEVICES_DETAIL_TECH: 'FMS_DEVICES_DETAIL_TECH_V2', // tab: technical detail
  FMS_DEVICES_DETAIL_EDIT: 'FMS_DEVICES_DETAIL_EDIT_V2', // action: edit device
  FMS_DEVICES_DETAIL_COMMAND: 'FMS_DEVICES_DETAIL_COMMAND_V2', // action: send command
  FMS_DEVICES_DETAIL_ON_OFF: 'FMS_DEVICES_DETAIL_ON_OFF_V2', // action: on/off engine
  FMS_DEVICES_DETAIL_MAP: 'FMS_DEVICES_DETAIL_MAP_V2', // section: show map
  FMS_DEVICES_DETAIL_STATISTIC: 'FMS_DEVICES_DETAIL_STATISTIC_V2', // Action button statistic

  // ─── DRIVERS ─────────────────────────────────────────────────────────────────
  FMS_DRIVERS: 'FMS_DRIVERS_V2', // PAGE DRIVERS

  // ─── GEOFENCE ────────────────────────────────────────────────────────────────
  FMS_GEOFENCE: 'FMS_GEOFENCE_V2', // PAGE GEOFENCE (read)
  FMS_GEOFENCE_MANAGE: 'FMS_GEOFENCE_MANAGE_V2', // action: create / edit / delete geofence
  FMS_GEOFENCE_WRITE: 'FMS_GEOFENCE_WRITE_V2', // alias for MANAGE (backward compat)
  FMS_GEOFENCE_ALERT: 'FMS_GEOFENCE_ALERT_V2', // PAGE ALERTS
  FMS_B2B_USER_V2: 'FMS_B2B_USER_V2', // Hide Alert for ALVA B2B

  // ─── GROUPS ──────────────────────────────────────────────────────────────────
  FMS_GROUPS: 'FMS_GROUPS_V2', // PAGE GROUPS

  // ─── DASHBOARD ───────────────────────────────────────────────────────────────
  FMS_DASHBOARD: 'FMS_DASHBOARD_V2', // PAGE DASHBOARD
  FMS_DASHBOARD_PHR: 'FMS_DASHBOARD_PHR_V2', // PAGE DASHBOARD PHR

  // ─── PRODUCTIVITY ────────────────────────────────────────────────────────────
  FMS_PRODUCTIVITY: 'FMS_PRODUCTIVITY_V2', // PAGE PRODUCTIVITY

  // ─── HISTORICAL / TRIPS ──────────────────────────────────────────────────────
  FMS_TRIPS: 'FMS_TRIPS_V2', // PAGE TRIPS (playback)
  FMS_TRIPS_DOWNLOAD: 'FMS_TRIPS_DOWNLOAD_V2',
  FMS_HISTORICAL_PHR: 'FMS_HISTORICAL_PHR_V2', // PAGE HISTORICAL PHR
  FMS_HISTORICAL_BUS: 'FMS_HISTORICAL_BUS_V2', // PAGE HISTORICAL BUS

  // ─── CYCLE ───────────────────────────────────────────────────────────────────
  FMS_CYCLE: 'FMS_CYCLE_V2', // PAGE CYCLE

  // ─── ROUTE ASSIGNMENT ────────────────────────────────────────────────────────
  FMS_ROUTE_ASSIGNMENT: 'FMS_ROUTE_ASSIGNMENT_V2', // PAGE PENUGASAN RUTE (kalista, indy loop)

  // ─── PRE DELIVERY ────────────────────────────────────────────────────────────
  FMS_PRE_DELIVERY: 'FMS_PRE_DELIVERY_V2', // PAGE PRE DELIVERY INSPECTION
  FMS_PRE_DELIVERY_TRACKING: 'FMS_PRE_DELIVERY_TRACKING_V2', // PAGE PRE DELIVERY TRACKING
  FMS_IOT_CHECK_PDI: 'FMS_IOT_CHECK_PDI_V2', // PAGE IOT CHECK PDI

  // ─── QUALITY CHECK / IOT ─────────────────────────────────────────────────────
  FMS_QUALITY_CHECK: 'FMS_QUALITY_CHECK_V2', // PAGE QUALITY CHECK (read)
  FMS_QUALITY_CHECK_WRITE: 'FMS_QUALITY_CHECK_WRITE_V2', // action: create/edit QC record
  FMS_IOT_CHECK: 'FMS_IOT_CHECK_V2', // PAGE SCAN IMEI / IOT CHECK
  FMS_IOT_CHECK_WRITE: 'FMS_IOT_CHECK_WRITE_V2', // action: write IoT data
  FMS_IOT_CHECK_AFTER_SALES: 'FMS_IOT_CHECK_AFTER_SALES_V2', // PAGE IOT CHECK AFTER SALES

  // ─── SUBSCRIPTIONS ───────────────────────────────────────────────────────────
  FMS_SUBSCRIPTIONS: 'FMS_SUBSCRIPTIONS_V2', // PAGE SUBSCRIPTIONS (read)
  FMS_SUBSCRIPTIONS_WRITE: 'FMS_SUBSCRIPTIONS_WRITE_V2', // action: create/edit subscriptions

  // ─── HISTORY ─────────────────────────────────────────────────────────────────
  FMS_ACCESS_HISTORY: 'FMS_ACCESS_HISTORY_V2', // PAGE ACCESS HISTORY
  FMS_COMMAND_HISTORY: 'FMS_COMMAND_HISTORY_V2', // PAGE COMMAND HISTORY
  FMS_TEST_HISTORY: 'FMS_TEST_HISTORY_V2', // PAGE TEST HISTORY (read)
  FMS_TEST_HISTORY_WRITE: 'FMS_TEST_HISTORY_WRITE_V2', // action: create/edit test record

  // ─── REPORT ──────────────────────────────────────────────────────────────────
  FMS_REPORT: 'FMS_REPORT_V2', // PAGE REPORT
  FMS_REPORT_BUS: 'FMS_REPORT_BUS_V2', // PAGE REPORT BUS (kalista)

  // ─── SPECIAL / UNGROUPED ─────────────────────────────────────────────────────
  FMS_HISTORICAL_ALVA: 'FMS_HISTORICAL_ALVA_V2', // PAGE HISTORICAL (alva/bike) — lama: FMS_READ_HISTORICAL
  FMS_ASSET_DETAIL_LIVETRACK: 'FMS_ASSET_DETAIL_LIVETRACK', // section: livetrack on asset detail
  FMS_FLEETO_ALVA: 'FMS_FLEETO_ALVA', // special: fleeto alva access
  FMS_DETACH_GRAB: 'FMS_DETACH_GRAB', // action: detach grab
  FMS_IDENTITY_MANAGER: 'FMS_IDENTITY_MANAGER', // special: identity manager access
}

export const PERMISSIONS = {
  // OLD PERMISSION
  FMS_EMERGENCY_COMMAND: 'FMS_EMERGENCY_COMMAND',
  FMS_DEVICE_COMMAND: 'FMS_DEVICE_COMMAND',
  FMS_SHARELOC_COMMAND: 'FMS_SHARELOC_COMMAND',
  FMS_READ_HISTORICAL: 'FMS_READ_HISTORICAL',
  FMS_READ_TECHNICAL_DETAIL: 'FMS_READ_TECHNICAL_DETAIL',
  FMS_REPORT_KALISTA: 'FMS_REPORT_KALISTA',
  FMS_READ_PRODUCTIVITY: 'FMS_READ_PRODUCTIVITY',
  FMS_READ_DASHBOARD: 'FMS_READ_DASHBOARD',
  FMS_ON_OFF_COMMAND: 'FMS_ON_OFF_COMMAND',
  FMS_READ_ALERT: 'FMS_READ_ALERT',
  FMS_READ_DEVICE: 'FMS_READ_DEVICE',
  FMS_READ_DRIVER: 'FMS_READ_DRIVER',
  FMS_READ_GEOFENCE: 'FMS_READ_GEOFENCE',
  FMS_READ_IOT_CHECK_AFTER_SALES: 'FMS_READ_IOT_CHECK_AFTER_SALES',
  FMS_READ_IOT: 'FMS_READ_IOT',
  FMS_READ_LIVETRACK: 'FMS_READ_LIVETRACK',
  FMS_READ_MANUFACTURE: 'FMS_READ_MANUFACTURE',
  FMS_READ_PREDELIVERY_ASSETS: 'FMS_READ_PREDELIVERY_ASSETS',
  FMS_READ_PREDELIVERY_TRACKING: 'FMS_READ_PREDELIVERY_TRACKING',
  FMS_READ_REPORT: 'FMS_READ_REPORT',
  FMS_READ_REPORT_GROUP: 'FMS_READ_REPORT_GROUP',
  FMS_READ_COMMAND_ACCESS_HISTORY: 'FMS_READ_COMMAND_ACCESS_HISTORY',
  FMS_READ_SUBSCRIPTIONS: 'FMS_READ_SUBSCRIPTIONS',
  FMS_READ_TEST_RECORD: 'FMS_READ_TEST_RECORD',
  FMS_READ_VEHICLE: 'FMS_READ_VEHICLE',
  FMS_READ_ROUTES: 'FMS_READ_ROUTES',
  FMS_ASSET_PLUS: 'FMS_ASSET_PLUS',
  FMS_READ_ASSET_BIKE: 'FMS_READ_ASSET_BIKE',
  FMS_READ_ASSET_CAR: 'FMS_READ_ASSET_CAR',
  FMS_TRACKING_PLUS: 'FMS_TRACKING_PLUS',
  FMS_SHOW_MAP: 'FMS_SHOW_MAP',
  FMS_WRITE_COMMAND: 'FMS_WRITE_COMMAND',
  FMS_WRITE_DEVICE: 'FMS_WRITE_DEVICE',
  FMS_WRITE_DRIVER: 'FMS_WRITE_DRIVER',
  FMS_WRITE_GEOFENCE: 'FMS_WRITE_GEOFENCE',
  FMS_WRITE_IOT: 'FMS_WRITE_IOT',
  FMS_WRITE_MANUFACTURE: 'FMS_WRITE_MANUFACTURE',
  FMS_WRITE_SUBSCRIPTIONS: 'FMS_WRITE_SUBSCRIPTIONS',
  FMS_WRITE_TEST_RECORD: 'FMS_WRITE_TEST_RECORD',
  FMS_WRITE_VEHICLE: 'FMS_WRITE_VEHICLE',
  READ_ORGANIZATION: 'READ_ORGANIZATION', // GROUP
  FMS_PHR_HISTORICAL: 'FMS_PHR_HISTORICAL',
  FMS_DASHBOARD_PHR: 'FMS_DASHBOARD_PHR',
  FMS_SET_PAT: 'WRITE_PAT',
}

export enum DateTypeOptions {
  LastOneHour = 'lastOneHour',
  Today = 'today',
  Yesterday = 'yesterday',
  DateRange = 'dateRange',
}

export const DATE_TYPE_OPTIONS = [
  {
    label: 'Last 1 Hour',
    value: DateTypeOptions.LastOneHour,
  },
  {
    label: 'Today',
    value: DateTypeOptions.Today,
  },
  {
    label: 'Yesterday',
    value: DateTypeOptions.Yesterday,
  },
  {
    label: 'Date Range',
    value: DateTypeOptions.DateRange,
  },
]

export const API_DATE_FORMAT = 'YYYY-MM-DD'

export const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const QC_OPTIONS = [
  {
    label: 'All',
    value: QC_FILTER.ALL,
  },
  {
    label: 'Passed',
    value: QC_FILTER.PASS,
  },
  {
    label: 'Failed',
    value: QC_FILTER.FAIL,
  },
]

export const STATUS_OPTIONS = [
  {
    label: 'All',
    value: DEVICES_FILTER_BY.ALL,
  },
  {
    label: 'Assigned',
    value: DEVICES_FILTER_BY.ASSIGNED,
  },
  {
    label: 'Unassigned',
    value: DEVICES_FILTER_BY.UNASSIGNED,
  },
]

export const statusVariantMapping = {
  completed: 'info',
  pending: 'pending',
  'no data available': 'default',
  failed: 'danger',
}

// Status icon mapping
export const iconStatusMapping = {
  [VEHICLE_STATUS.IDLE]: idleIcon,
  [VEHICLE_STATUS.MOVING]: onlineIcon,
  [VEHICLE_STATUS.STOP]: offlineIcon,
  [VEHICLE_STATUS.NA]: offlineIcon,
}

// Mapping vehicle status color variant
export const variantStatusMapping = {
  [VEHICLE_STATUS.IDLE]: 'warning',
  [VEHICLE_STATUS.MOVING]: 'success',
  [VEHICLE_STATUS.STOP]: 'danger',
  [VEHICLE_STATUS.NA]: 'default',
}
export const DEFAULT_ZOOM_RADIUS = 10

export const FLEET_MODEL = {
  ALVA2: 'ALVA2',
}

export const DEVICE_MODEL = {
  CAN: 'TFT100 CAN',
}

// device models that read the CAN battery data (battery 1 / 2, anti-theft);
// matched with includes, see isCanDeviceModel in ~/utils/deviceModel
export const CAN_DEVICE_MODELS = [DEVICE_MODEL.CAN, 'FMC150', 'FMC650']

export const FLEET_MODEL_DEVICE = {
  'TFT100 RS485': 'ALVA ONE',
  'TFT100 CAN': 'ALVA CERVO',
}

export const centerJakarta = [-6.22678, 106.798186]

export const logoLoginMapping = {
  [DOMAINS.FLEETO_ALVA_DOMAIN as string]: '/public/brands/alva-dark.svg',
  [DOMAINS.FLEETO_MAIN_DOMAIN as string]: '/public/brands/logo-fleeto-v4.svg',
  [SUBDOMAINS.FLEETO_XL_SUBDOMAIN as string]: '/public/brands/xl-smart.svg',
  [SUBDOMAINS.FLEETO_TRICON_SUBDOMAIN as string]:
    '/public/brands/tricon-logo.png',
  [SUBDOMAINS.FLEETO_KALISTA_SUBDOMAIN as string]:
    '/public/brands/logo-kalista-green.png',
  [SUBDOMAINS.FLEETO_KALISTA_K_MOVE_SUBDOMAIN as string]:
    '/public/brands/logo-kalista-green.png',
}

// Mapping subdomain/domain to org code used by createDynamicTheme when there is no logged in user yet (e.g. login page)
export const orgCodeLoginMapping = {
  [SUBDOMAINS.FLEETO_XL_SUBDOMAIN as string]: 'xl',
  [SUBDOMAINS.FLEETO_TRICON_SUBDOMAIN as string]: 'tricon',
  [SUBDOMAINS.FLEETO_KALISTA_SUBDOMAIN as string]: 'kalista',
  [SUBDOMAINS.FLEETO_KALISTA_K_MOVE_SUBDOMAIN as string]: 'kalista',
}

export const REPLAY_CONTROL = {
  PAUSE: 'PAUSE',
  PLAY: 'PLAY',
  SKIP_NEXT: 'SKIP_NEXT',
  SKIP_PREVIOUS: 'SKIP_PREVIOUS',
  SPEED_CONTROL: 'SPEED_CONTROL',
  STOP: 'STOP',
}

export const ICON_ASSETS_MENU = {
  kalista: '/public/images/bus.svg',
  xapiens: '/public/images/car.svg',
}

export const DYNAMIC_ASSET_ICON_MENU = {
  kalista: <ReactSVG src="/public/icons/menu-icon/bus.svg" />,
  xapiens: <ReactSVG src="/public/icons/menu-icon/car.svg" />,
}

export const REMARKS_LABEL = {
  kalista: 'Customer',
  xapiens: 'Group',
}

export const KIDECO_SPEED_POINT = [
  {
    type: 'W',
    latitude: -1.847486299,
    longitude: 115.885596994,
    description: 'Point_Speed 1 21',
  },
  {
    type: 'W',
    latitude: -1.725413084,
    longitude: 115.828412523,
    description: 'Point_Speed 1 1',
  },
  {
    type: 'W',
    latitude: -1.837887704,
    longitude: 115.900486486,
    description: 'Point_Speed 1 2',
  },
  {
    type: 'W',
    latitude: -1.889702786,
    longitude: 115.916021025,
    description: 'Point_Speed 1 5',
  },
  {
    type: 'W',
    latitude: -1.825338699,
    longitude: 116.154772381,
    description: 'Point_Speed 1 6',
  },
  {
    type: 'W',
    latitude: -1.903368554,
    longitude: 115.893321625,
    description: 'Point_Speed 1 7',
  },
  {
    type: 'W',
    latitude: -1.906252081,
    longitude: 115.895087469,
    description: 'Point_Speed 1 8',
  },
  {
    type: 'W',
    latitude: -1.908361716,
    longitude: 115.86134547,
    description: 'Point_Speed 1 9',
  },
  {
    type: 'W',
    latitude: -1.90035568,
    longitude: 115.85130754,
    description: 'Point_Speed 1 10',
  },
  {
    type: 'W',
    latitude: -1.884098803,
    longitude: 115.860596024,
    description: 'Point_Speed 1 11',
  },
  {
    type: 'W',
    latitude: -1.92556851,
    longitude: 115.855248393,
    description: 'Point_Speed 1 12',
  },
  {
    type: 'W',
    latitude: -1.945283451,
    longitude: 115.866712448,
    description: 'Point_Speed 1 13',
  },
  {
    type: 'W',
    latitude: -1.981438003,
    longitude: 115.879136329,
    description: 'Point_Speed 1 14',
  },
  {
    type: 'W',
    latitude: -1.934259805,
    longitude: 115.892406599,
    description: 'Point_Speed 1 15',
  },
  {
    type: 'W',
    latitude: -1.864285011,
    longitude: 115.893334938,
    description: 'Point_Speed 1 16',
  },
  {
    type: 'W',
    latitude: -1.857940779,
    longitude: 115.89198066,
    description: 'Point_Speed 1 17',
  },
  {
    type: 'W',
    latitude: -1.85208648,
    longitude: 115.88953802,
    description: 'Point_Speed 1 18',
  },
  {
    type: 'W',
    latitude: -1.842077411,
    longitude: 115.869991329,
    description: 'Point_Speed 1 19',
  },
  {
    type: 'W',
    latitude: -1.927971202,
    longitude: 115.858548174,
    description: 'Point_Speed 1 20',
  },
  {
    type: 'W',
    latitude: -1.884702893,
    longitude: 115.913972745,
    description: 'Point_Speed 1 22',
  },
  {
    type: 'W',
    latitude: -1.870395,
    longitude: 115.91624,
    description: 'Point_Speed 1 25',
  },
  {
    type: 'W',
    latitude: -1.868619,
    longitude: 115.916288,
    description: 'Point_Speed 1 26',
  }, // Area Biru
  {
    type: 'B',
    latitude: -1.874444,
    longitude: 115.913889,
    description: 'Point_Speed 1 27',
  },
  {
    type: 'B',
    latitude: -1.873611,
    longitude: 115.914167,
    description: 'Point_Speed 1 28',
  },
  {
    type: 'B',
    latitude: -1.869722,
    longitude: 115.913333,
    description: 'Point_Speed 1 29',
  },
  {
    type: 'B',
    latitude: -1.865556,
    longitude: 115.913611,
    description: 'Point_Speed 1 30',
  },
  {
    type: 'B',
    latitude: -1.854722,
    longitude: 115.911667,
    description: 'Point_Speed 1 31',
  },
  {
    type: 'B',
    latitude: -1.849722,
    longitude: 115.911667,
    description: 'Point_Speed 1 32',
  },
  {
    type: 'B',
    latitude: -1.849167,
    longitude: 115.909722,
    description: 'Point_Speed 1 33',
  },
  {
    type: 'B',
    latitude: -1.848333,
    longitude: 115.908056,
    description: 'Point_Speed 1 34',
  },
  {
    type: 'B',
    latitude: -1.845556,
    longitude: 115.905833,
    description: 'Point_Speed 1 35',
  },
  {
    type: 'B',
    latitude: -1.845278,
    longitude: 115.905556,
    description: 'Point_Speed 1 36',
  },
  {
    type: 'B',
    latitude: -1.843611,
    longitude: 115.902778,
    description: 'Point_Speed 1 37',
  },
  {
    type: 'B',
    latitude: -1.84,
    longitude: 115.900556,
    description: 'Point_Speed 1 38',
  },
  {
    type: 'B',
    latitude: -1.839167,
    longitude: 115.899722,
    description: 'Point_Speed 1 39',
  },
  {
    type: 'B',
    latitude: -1.837778,
    longitude: 115.900278,
    description: 'Point_Speed 1 40',
  },
  {
    type: 'B',
    latitude: -1.840556,
    longitude: 115.898889,
    description: 'Point_Speed 1 41',
  },
  {
    type: 'B',
    latitude: -1.840556,
    longitude: 115.897778,
    description: 'Point_Speed 1 42',
  },
  {
    type: 'B',
    latitude: -1.84,
    longitude: 115.896389,
    description: 'Point_Speed 1 43',
  },
  {
    type: 'B',
    latitude: -1.840833,
    longitude: 115.893611,
    description: 'Point_Speed 1 44',
  },
  {
    type: 'B',
    latitude: -1.841944,
    longitude: 115.892222,
    description: 'Point_Speed 1 45',
  },
  {
    type: 'B',
    latitude: -1.843889,
    longitude: 115.890833,
    description: 'Point_Speed 1 46',
  },
  {
    type: 'B',
    latitude: -1.845278,
    longitude: 115.891389,
    description: 'Point_Speed 1 47',
  },
  {
    type: 'B',
    latitude: -1.845833,
    longitude: 115.890556,
    description: 'Point_Speed 1 48',
  },
  {
    type: 'B',
    latitude: -1.846111,
    longitude: 115.888056,
    description: 'Point_Speed 1 49',
  },
  {
    type: 'B',
    latitude: -1.846389,
    longitude: 115.886944,
    description: 'Point_Speed 1 50',
  },
  {
    type: 'B',
    latitude: -1.847222,
    longitude: 115.885556,
    description: 'Point_Speed 1 51',
  },

  // Area Kuning
  {
    type: 'K',
    latitude: -1.868611,
    longitude: 115.916111,
    description: 'Point_Speed 1 52',
  },
  {
    type: 'K',
    latitude: -1.868889,
    longitude: 115.914167,
    description: 'Point_Speed 1 53',
  },
  {
    type: 'K',
    latitude: -1.870556,
    longitude: 115.914167,
    description: 'Point_Speed 1 54',
  },
  {
    type: 'K',
    latitude: -1.872222,
    longitude: 115.914722,
    description: 'Point_Speed 1 55',
  },
  {
    type: 'K',
    latitude: -1.873056,
    longitude: 115.915,
    description: 'Point_Speed 1 56',
  },
  {
    type: 'K',
    latitude: -1.870278,
    longitude: 115.916111,
    description: 'Point_Speed 1 57',
  },
]

export const KALISTA_FLEET_TYPES = ['bus', 'truck']
